import { Schedule, Check, HourglassEmpty, Psychology, HowToReg, Cancel, LooksOne } from "@mui/icons-material";
import { Box, SxProps, Typography } from "@mui/material";
import { Avatar } from "../fieldsViews/fields/Avatar";
import { OverlayEventContent } from "./overlay/OverlayEventContent";
import { OverlayEvent } from "./overlay/overlay.types";

interface CustomEventProps {
    event: {
        title: string;
        technicianName: string;
        technicianAvatar: string;
        status?: string;
        is_first_session?: boolean;
        internal_meetings_participants?: string[];
        overlayType?: "schedule" | "time_off";
        serviceIds?: Array<number>;
        userName?: string;
        isBackoffice?: boolean;
    };
}

export const CustomEventWeek = ({ event }: CustomEventProps) => {
    if (event.overlayType) return <OverlayEventContent event={event as unknown as OverlayEvent} />;
    return (
        <Box display="flex" alignItems="flex-start" width="100%" sx={{ position: "relative" }}>
            <Typography variant="caption">{event.title}</Typography>
            <Typography variant="caption" sx={{ ml: 1 }}>
                {event.technicianName}
            </Typography>
            <Box position="absolute" top={-15} left={30}>
                <Status status={event.status} styles={{ width: 15, height: 15 }} />
                {event.is_first_session && <LooksOne titleAccess="Primeira sessão" sx={{ width: 15, height: 15 }} />}
            </Box>
            {renderEventAvatars(event, { ml: 1, width: 25, height: 25 })}
        </Box>
    );
};

export const CustomEventDay = ({ event }: CustomEventProps) => {
    if (event.overlayType) return <OverlayEventContent event={event as unknown as OverlayEvent} />;
    return (
        <Box display="flex" alignItems="flex-start" width="100%" sx={{ position: "relative" }}>
            <Typography variant="caption">{event.title}</Typography>
            <Box position="absolute" top={-15} left={30}>
                <Status status={event.status} styles={{ width: 15, height: 15 }} />
                {event.is_first_session && <LooksOne titleAccess="Primeira sessão" sx={{ width: 15, height: 15 }} />}
            </Box>
            {renderEventAvatars(event, { ml: 5, mt: -3, width: 30, height: 30 })}
        </Box>
    );
};

export const CustomEventAgenda = ({ event }: CustomEventProps) => {
    return (
        <Box display="flex" alignItems="center" width="100%">
            <Typography variant="caption">{event.title}</Typography>
            <Box>
                <Status status={event.status} styles={{ width: 15, height: 15, ml: 1 }} />
                {event.is_first_session && <LooksOne titleAccess="Primeira sessão" sx={{ width: 15, height: 15 }} />}
            </Box>
            {renderEventAvatars(event, { ml: "auto", width: 30, height: 30 })}
        </Box>
    );
};

const Status = ({ status, styles }: { status?: string; styles: SxProps }) => {
    switch (status) {
        case "booked":
            return <Schedule sx={styles} />;
        case "confirmed":
            return <Check sx={styles} />;
        case "awaiting_in_clinic":
            return <HourglassEmpty sx={styles} />;
        case "in_session":
            return <Psychology sx={styles} />;
        case "done":
            return <HowToReg sx={styles} />;
        case "canceled":
            return <Cancel sx={styles} />;
        case "missed":
            return <Cancel sx={styles} />;
        default:
            return null;
    }
};

const renderEventAvatars = (event: CustomEventProps["event"], avatarStyles: SxProps) => {
    const allAvatars = [];

    if (event.technicianAvatar) {
        allAvatars.push(<Avatar key="technician" value={event.technicianAvatar} styles={avatarStyles} />);
    }

    if (event.internal_meetings_participants && event.internal_meetings_participants.length > 0) {
        event.internal_meetings_participants.forEach((participant) => {
            allAvatars.push(<Avatar key={participant} value={participant} styles={avatarStyles} />);
        });
    }

    return allAvatars;
};
